import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_MASTER_OVER_TIME_FORMULAS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_MASTER_OVER_TIME_FORMULA:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_MASTER_OVER_TIME_FORMULA:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_MASTER_OVER_TIME_FORMULA:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_MASTER_OVER_TIME_FORMULA:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
